export const appStageToTitle = (stage: string) => {
    switch (stage.toLowerCase()) {
        case "production":
            return "LCCV";
        case "readiness":
            return "Perun4V";
        default:
            return "Perun4V";
    }
};
